import { cellVolume } from './structure';
import type { Building, Cell } from '../world/city';

/** Material fragments use the volume fraction already present in the mass
 * model. Bounds stay centred on the original cell: mass, COM and inherited point
 * velocity survive refinement, while panes/slabs/beams stop looking like cubes.
 */
export function refineFragment(cell: Cell, building: Building): void {
  if (cell.bounds || cell.material === 'foliage') return;
  const volume = cellVolume(cell);
  let w = 1,
    h = 1,
    d = 1;
  if (cell.role === 'column') w = d = Math.sqrt(volume);
  else if (cell.role === 'slab' || cell.role === 'roof') h = volume;
  else if (cell.role === 'beam') {
    h = 0.4;
    d = Math.min(1, volume / h);
  } else {
    const side = cell.x === 0 || cell.x === building.w - 1;
    if (side) w = volume;
    else d = volume;
  }
  cell.bounds = { x: (1 - w) / 2, y: (1 - h) / 2, z: (1 - d) / 2, w, h, d };
}
